module.exports = __webpack_public_path__ + "static/media/Money.4df42ae4.svg";